import React from 'react';
import background from '../../assets/flora.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoFlorafauna extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Flora & Fauna"
        paragraph="The Arctic is the northernmost region of our planet, rich in biodiversity and resources. Its white surface helps regulate our climate by reflecting solar energy."
        background={background}
     />
  
  );
 }
}   

export default InfoFlorafauna;